/**
 * GTINs (ADR-087): the numbers under a barcode that search engines match a
 * product by. A barcode is one only when it is 8, 12, 13 or 14 digits and its
 * GS1 check digit is right — otherwise it is a store's own code, kept as it is.
 */
const LENGTHS = new Set([8, 12, 13, 14]);
/** The barcode as a GTIN, or null when it is not one. */
export function gtinOf(barcode) {
    const code = barcode?.trim() ?? '';
    if (!/^\d+$/.test(code) || !LENGTHS.has(code.length))
        return null;
    const digits = [...code].map(Number);
    const check = digits.pop();
    // From the right, the digits weigh 3, 1, 3, 1… — the same rule for every length.
    const sum = digits.reverse().reduce((total, digit, index) => total + digit * (index % 2 === 0 ? 3 : 1), 0);
    return (10 - (sum % 10)) % 10 === check ? code : null;
}
/** The schema.org property a GTIN goes in: `gtin8`, `gtin12`, `gtin13` or `gtin14`. */
export function gtinProperty(gtin) {
    return `gtin${gtin.length}`;
}
//# sourceMappingURL=gtin.js.map